
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import { useHelpBody } from '@/views/help/use-help-body'
export default defineComponent({
  setup () {
    const { t } = useI18n()
    useHelpBody()

    return {
      t,
    }
  },
})
